import commonUtil from '../../../../utils/commonUtil';

export const CONTRACT_PAGE_LOAD = 'CONTRACT_PAGE_LOAD';
export const CONTRACT_PAGE_LOAD_SUCCESS = 'CONTRACT_PAGE_LOAD_SUCCESS';
export const CONTRACT_PAGE_LOAD_FAIL = 'CONTRACT_PAGE_LOAD_FAIL';

export const SET_PAGE_FLAG = 'SET_PAGE_FLAG';

export function isContractPageLoaded(globalState) {
  return globalState.contractPage && globalState.contractPage.loaded;
}

export function loadContractPage(eventType, eventDate) {
  const contractDetails = {};
  contractDetails.eventType = eventType;
  contractDetails.eventDate = eventDate;
  contractDetails.brand = commonUtil.getBrand().toUpperCase();
  contractDetails.channel = commonUtil.getChannel().toUpperCase();
  return {
    types: [CONTRACT_PAGE_LOAD, CONTRACT_PAGE_LOAD_SUCCESS, CONTRACT_PAGE_LOAD_FAIL],
    promise: client => client.post('/api/CreateEvent/ContractDetails', {
      data: (contractDetails),
    }),
  };
}

export const setPageFlag = flagValue => ({ type: SET_PAGE_FLAG, data: flagValue });
